module.exports = __webpack_public_path__ + "img/ruou_vang_2.87d93c11.jpg";